<template>
   <div class="pr-4 user-select-none" style="font-size: 1.35rem">
      <b-icon-sliders
         style="outline: none"
         aria-label="Filter"
         role="button"
         :id="`popover-filters-icon`"
      ></b-icon-sliders>
      <b-popover triggers="click blur" placement="bottom" :target="`popover-filters-icon`">
         <b-form-group class="checkbox-group" label="Filter by Stage:" v-slot="{ariaDescribedby}">
            <b-form-checkbox-group
               class="d-flex gap-3 flex-column checkboxes"
               id="checkbox-group"
               v-model="selected"
               :options="options"
               :aria-describedby="ariaDescribedby"
            ></b-form-checkbox-group>
         </b-form-group>
      </b-popover>
   </div>
</template>

<script>
import {StudyStage} from '../../../store/models/study';

export default {
   name: 'StaffTableFilter',

   data() {
      return {
         selected: [],
         options: [
            {value: StudyStage.NO_OPEN_STUDY, text: 'No Open Study'},
            {value: StudyStage.CLIENT_INFO_COLLECTION, text: 'Client Info Collection'},
            {value: StudyStage.RDIG_STUDY_SETUP, text: 'RDIG Study Setup'},
            {value: StudyStage.CLIENT_DATA_COLLECTION, text: 'Client Data Collection'},
            {value: StudyStage.RDIG_DATA_REVIEW, text: 'RDIG Data Review'},
            {value: StudyStage.RDIG_CREDIT_CALCULATION, text: 'RDIG Credit Calculation'},
            {value: StudyStage.DELIVERED, text: 'Delivered'},
         ],
      };
   },

   watch: {
      selected(newValue) {
         this.$emit('onStageChange', newValue);
      },
   },
};
</script>

<style scoped lang="scss">
.checkbox-group {
   font-size: 0.8rem;
}

.checkboxes ::v-deep .custom-control-label {
   font-size: 0.75rem;
   padding-top: 0.2rem;
}
</style>
